import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { HealthSystemDomainDiseasesDiseaseViewModel } from '../api/HealthSystemApi';

interface FarmDiseaseSelectProps {
  diseases: HealthSystemDomainDiseasesDiseaseViewModel[];
  value: string;
  onSupplyChange: (value: string) => void;
  cssClass?: string;
  fullWidth?: boolean;
  allowAny?: boolean;
  disabled?: boolean;
  selectId?: string;
  labelText?: string;
}

const FarmDiseaseSelect = ({
  diseases,
  value,
  onSupplyChange,
  cssClass,
  fullWidth,
  allowAny,
  disabled,
  selectId,
  labelText
}: FarmDiseaseSelectProps) => {
  const { t } = useTranslation();

  const handleSupplyChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const supplyValue = event.target.value as string;

    //callback
    onSupplyChange && onSupplyChange(supplyValue);
  };

  return (
    <FormControl className={cssClass} disabled={disabled} fullWidth={fullWidth} variant="outlined" size="small">
      <InputLabel id="farmDiseaseLabel">{labelText || t('f-disease')}</InputLabel>
      <Select
        // Must match the InputLabel: the outlined variant sizes the notch in the border from this.
        label={labelText || t('f-disease')}
        labelId="farmDiseaseLabel"
        id={selectId || 'FarmDiseaseSelect'}
        value={value}
        onChange={handleSupplyChange}
      >
        {allowAny && (
          <MenuItem key={'any'} value={'any'}>
            {t('f-any')}
          </MenuItem>
        )}

        {diseases.map((disease) => (
          <MenuItem key={disease.id} value={disease.id}>
            {disease.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FarmDiseaseSelect;
